<template>
  <div class="payment-container">
    <v-layout row wrap v-if="$currentUrl === 'RegisterMember'">
      <v-flex lg1 md1 sm6 xs12>
        <v-container>
          <v-btn
            small
            @click="back()"
            depressed
            block
            color="#587e27"
            class="futuristic-btn"
          >
            Back
          </v-btn>
        </v-container>
      </v-flex>
      <v-flex lg2 md2 sm6 xs12>
        <v-container>
          <v-btn
            @click="resetData()"
            color="#e84118"
            depressed
            block
            small
            class="futuristic-btn"
          >
            Start Over
          </v-btn>
        </v-container>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex lg1 hidden-md-and-below>
        <!-- <membership-cart style="margin-top: 20%"></membership-cart> -->
      </v-flex>
      <v-flex lg10 md12>
        <v-container fluid>
          <div class="card-header">
            <h1 class="text-md-center earth-color">ADD A CORPORATE MEMBER</h1>
            <div class="title-decoration"></div>
          </div>
          <v-form @submit.prevent="postCorporateMember()" ref="form" v-model="valid">
            <v-card flat class="futuristic-card">
              <v-container fluid>
                <h2 class="donation-title earth-color">Corporate Membership Details</h2>
                <div class="title-decoration"></div>
                <v-layout row wrap>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Member ID"
                        v-model="member.member_id"
                        :rules="requiredRules"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-dialog
                        ref="dialog2"
                        persistent
                        v-model="modal2"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="member.expiry_date"
                      >
                        <v-text-field
                          v-slot:activator
                          label="Membership Expiry Date"
                          v-model="member.expiry_date"
                          :rules="requiredRules"
                          readonly
                          class="futuristic-input"
                        ></v-text-field>
                        <v-date-picker v-model="member.expiry_date" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn
                            depressed
                            text
                            color="#587e27"
                            @click="modal2 = false"
                            class="futuristic-btn"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            depressed
                            text
                            color="#587e27"
                            @click="$refs.dialog2.save(member.expiry_date)"
                            class="futuristic-btn"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.company_name"
                        :rules="requiredRules"
                        label="Company Name"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.contact_person_name"
                        :rules="requiredRules"
                        label="Contact Person Name"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.postal_address"
                        :rules="requiredRules"
                        label="Postal Address"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.postal_code"
                        :rules="requiredRules"
                        label="Postal Code"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md6 sm12 xs12>
                    <v-container>
                      <v-autocomplete
                        label="Country"
                        v-model="member.code"
                        :items="allCountries"
                        :rules="[v => !!v || 'Country is required']"
                        required
                        item-text="name"
                        item-value="code"
                        @change="findCountryCode"
                        :loading="$loadingTrue"
                        class="futuristic-input"
                      ></v-autocomplete>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.phone_number"
                        :rules="requiredRules"
                        label="Company Phone Number (e.g. +XXX...)"
                        required
                        minlength="13"
                        type="text"
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.contact_person_phone_number"
                        :rules="requiredRules"
                        label="Contact Phone Number (e.g. +XXX...)"
                        required
                        minlength="13"
                        type="text"
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.town"
                        :rules="requiredRules"
                        label="Town/City"
                        required
                        type="text"
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md5 sm12 xs12>
                    <v-container>
                      <v-select
                        label="Payment Method"
                        v-model="member.payment_method"
                        :items="['Mpesa', 'Credit Card', 'Bank Transfer', 'Cheque', 'Voucher']"
                        :rules="requiredRules"
                        required
                        :loading="$loadingTrue"
                        class="futuristic-input"
                      ></v-select>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Amount Paid"
                        v-model="member.amount"
                        :rules="requiredRules"
                        required
                        type="number"
                        min="0"
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="No of Vehicles"
                        v-model="member.vehicles"
                        :rules="requiredRules"
                        required
                        type="number"
                        min="0"
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="No of Passengers"
                        v-model="member.passengers"
                        :rules="requiredRules"
                        required
                        type="number"
                        min="0"
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="No of Visits per Year"
                        v-model="member.visits"
                        :rules="requiredRules"
                        required
                        type="number"
                        min="0"
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Salesforce Opportunity ID"
                        v-model="member.salesforce_uuid"
                        :rules="requiredRules"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Salesforce Contact ID"
                        v-model="member.salesforce_contact_uuid"
                        :rules="requiredRules"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        label="Salesforce Account ID"
                        v-model="member.salesforce_account_uuid"
                        :rules="requiredRules"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.email"
                        :rules="emailRules"
                        label="Email"
                        required
                        type="email"
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.email1"
                        :rules="optionalEmailRules"
                        label="Another Email"
                        type="email"
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.email2"
                        :rules="optionalEmailRules"
                        label="Another Email"
                        type="email"
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-container>
                <v-switch
                  color="#587e27"
                  label="Is Paid"
                  v-model="member.payment_status"
                  required
                  class="futuristic-input"
                ></v-switch>
              </v-container>
              <v-btn
                depressed
                color="#587e27"
                type="submit"
                block
                large
                class="futuristic-btn donate-btn"
              >
                Complete Registration
              </v-btn>
            </v-card>
          </v-form>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'CorporateMember',
  components: { Datepicker },
  data () {
    return {
      valid: true,
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      optionalEmailRules: [
        v => !v || /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      modal2: false,
      member: {
        member_id: '',
        company_name: '',
        email: '',
        email1: '',
        email2: '',
        phone_number: '',
        contact_person_name: '',
        contact_person_phone_number: '',
        salesforce_uuid: '',
        postal_address: '',
        postal_code: '',
        salesforce_contact_uuid: '',
        salesforce_account_uuid: '',
        expiry_date: '',
        payment_status: '',
        payment_method: '',
        amount: '',
        town: '',
        country: '',
        code: '',
        passengers: '',
        vehicles: '',
        visits: ''
      }
    }
  },
  created () {
    this.$store.dispatch('get_all_countries')
  },
  methods: {
    findCountryCode (data) {
      var instance = this
      this.allCountries.map(function (country) {
        if (data === country.code) {
          instance.member.phone_number = '+' + country.calling_code
          instance.member.contact_person_phone_number = '+' + country.calling_code
          instance.member.code = country.calling_code
        }
      })
    },
    postCorporateMember () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('post_corporate_member', this.member)
      }
    },
    resetData () {
      this.member = {
        member_id: '',
        company_name: '',
        email: '',
        email1: '',
        email2: '',
        phone_number: '',
        contact_person_name: '',
        contact_person_phone_number: '',
        salesforce_uuid: '',
        postal_address: '',
        postal_code: '',
        salesforce_contact_uuid: '',
        salesforce_account_uuid: '',
        expiry_date: '',
        payment_status: '',
        payment_method: '',
        amount: '',
        town: '',
        country: '',
        code: '',
        passengers: '',
        vehicles: '',
        visits: ''
      }
    },
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
/* Futuristic Container */
.payment-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.payment-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 2rem;
}

.donation-title {
  color: #587e27;
  font-weight: 600;
  font-size: 1.5rem;
  margin-bottom: 8px;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.donate-btn {
  font-size: 1.1rem;
  padding: 12px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .payment-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.75rem;
  }

  .donation-title {
    font-size: 1.25rem;
  }

  .futuristic-btn {
    font-size: 0.9rem;
  }
}

@media (max-width: 600px) {
  .payment-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.5rem;
  }

  .donation-title {
    font-size: 1.1rem;
  }

  .futuristic-btn {
    font-size: 0.85rem;
  }

  .donate-btn {
    font-size: 1rem;
    padding: 10px;
  }
}
</style>
